module.exports = __webpack_public_path__ + "quotezone-ui/img/top-bottom-black.af8c7f21.gif";